module.exports = __webpack_public_path__ + "static/media/Jose_Graziano_tablet.0a7b9cc7.jpg";